import axios from "axios"

export default {
	user: null,

	getMySections() {
		return axios.get(`/v1/my_sections`)
	},

	getContextPrefilled() {
		return axios.get(`/v1/context/prefilled`)
	},

	getTeam(teamID) {
		return axios.get(`/v1/teams/${teamID}`)
	},

	addTeam(team) {
		return axios.post(`/v1/teams`, team)
	},

	deleteTeam(teamID) {
		return axios.delete(`/v1/teams/${teamID}`)
	},

	assignTeam(sectionID, userID, teamID) {
		return axios.post(`/v1/assign_team/${sectionID}/${userID}/${teamID}`)
	},

	unassignTeam(sectionID, userID) {
		return axios.post(`/v1/unassign_team/${sectionID}/${userID}`)
	},

	getContextTeam() {
		return axios.get(`/v1/context/team`)
	},

	regenJoinCode(teamID) {
		console.log("regen join code")
		return axios.post(`v1/context/regen_code/team/${teamID}`)
	},

	inviteUser(email, team_id, template) {
		let ctx = {
			email: email,
			team_id: team_id,
			template: template,
		}

		return axios.post(`/v1/context/invite_user/team`, ctx)
	},

	addStudent(teamID, studentID) {
		return axios.post(`v1/teams/${teamID}/students/${studentID}`)
	}
}